import React, { Component } from 'react'
import styled from 'styled-components'

const Item = styled.div`
  margin-top: 5vh;
  padding-top: 2.5vh;
  padding-bottom: 2.5vh;
  width: 100vw;
  text-align: center;
  font-family: OpensansRegular;
  font-size: 3vw;
  text-transform: uppercase;
  color: white;
  //   background-color: red;
`
const ItemMarked = Item.extend`
  font-family: OpensansBold;
`
const FilterItem = ({ marked, label, onClick, style }) => {
  if (marked) {
    return <ItemMarked style={{ ...style }}>{label}</ItemMarked>
  } else {
    return (
      <Item onClick={() => onClick()} style={{ ...style }}>
        {label}
      </Item>
    )
  }
}

export default FilterItem



// WEBPACK FOOTER //
// ./src/components/filter-item-mobile.js